import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María', 'Luciana', 'Valentina', 'Camila', 'Sofía', 'Florencia', 'Agustina', 'Martina', 'Carolina', 'Paula', 'Julieta', 'Micaela'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 20000);
    // Recurring timer
    const interval = setInterval(showPopup, 45000); // Every 45 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-337">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 bg-white border border-border rounded-xl shadow-deep p-4 flex items-center gap-4 max-w-[320px]" data-id="element-338">
          <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-339">
            <span className="text-gold-dark font-serif font-medium text-lg" data-id="element-340">
              {currentData.name.charAt(0)}
            </span>
          </div>
          <div data-id="element-341">
            <p className="text-sm text-ink font-medium" data-id="element-342">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-xs text-ink-soft mt-0.5" data-id="element-343">
              accedió ahora al{' '}
              <span className="text-gold-dark font-medium" data-id="element-344">
                Sistema Completo
              </span>
            </p>
            <p className="text-[10px] text-ink-soft/60 mt-1" data-id="element-345">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}